/**
 * These are the froala resources and plugins that extend the viewer/editor.
 *
 * IMPORTANT
 * Do not import the resources in an es6 way, like so:
 * ```ts
 * import "froala-editor/css/froala_style.min.css"
 * ```
 *
 * If you do, webpack will prune it because it will detect it as a side effect, because in the typescript build directory, it stays as es6: `import ...`
 * AND we have `"sideEffects": true` within package.json
 */
(function bootstrapFroala() {
  //import('froala-editor/css/froala_style.min.css');

  import('froala-editor/css/froala_editor.pkgd.min.css');
  import('froala-editor/js/froala_editor.pkgd.min.js');

  import('froala-editor/js/plugins/align.min.js');

  import('froala-editor/js/plugins/code_view.min.js');

  import('froala-editor/css/plugins/code_view.min.css');

  import('froala-editor/css/plugins/colors.min.css');
  import('froala-editor/js/plugins/colors.min.js');

  import('froala-editor/js/plugins/draggable.min.js');

  import('froala-editor/css/plugins/draggable.min.css');

  import('froala-editor/js/plugins/emoticons.min.js');

  import('froala-editor/css/plugins/emoticons.min.css');

  import('froala-editor/js/plugins/entities.min.js');

  import('froala-editor/js/plugins/file.min.js');

  import('froala-editor/css/plugins/file.min.css');

  import('froala-editor/js/plugins/font_family.min.js');
  import('froala-editor/js/plugins/font_size.min.js');

  import('froala-editor/js/plugins/fullscreen.min.js');

  import('froala-editor/css/plugins/fullscreen.min.css');

  import('froala-editor/js/plugins/image.min.js');

  import('froala-editor/css/plugins/image.min.css');

  import('froala-editor/js/plugins/inline_style.min.js');

  import('froala-editor/js/plugins/line_breaker.min.js');

  import('froala-editor/css/plugins/line_breaker.min.css');

  import('froala-editor/js/plugins/line_height.min.js');

  import('froala-editor/js/plugins/link.min.js');

  import('froala-editor/js/plugins/lists.min.js');

  import('froala-editor/js/plugins/paragraph_format.min.js');

  import('froala-editor/js/plugins/paragraph_style.min.js');

  import('froala-editor/js/plugins/quote.min.js');

  import('froala-editor/js/plugins/special_characters.min.js');

  import('froala-editor/css/plugins/special_characters.min.css');

  import('froala-editor/js/plugins/table.min.js');

  import('froala-editor/css/plugins/table.min.css');

  import('froala-editor/js/plugins/url.min.js');

  import('froala-editor/js/plugins/video.min.js');

  import('froala-editor/css/plugins/video.min.css');
  import('froala-editor/css/plugins/markdown.min.css');
  import('froala-editor/css/plugins/special_characters.min.css');
})();
